import { Flex, LinkBox, LinkOverlay } from '@chakra-ui/react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { ChevronRightIcon } from '@udacity/chakra-uds-icons';

import { Job } from '../models/careers';

export function JobList({ jobs }: { jobs: Job[] }) {
  return (
    <Flex flexDirection='column' gap='16px' margin='24px 0' overflow='auto'>
      {jobs?.map((job) => <JobCard key={job.id} job={job} />)}
    </Flex>
  );
}

export function JobCard({ job }: { job: Job }) {
  return (
    <LinkBox
      alignItems='center'
      as='article'
      backgroundColor='white'
      border='1px solid'
      borderColor='gray.200'
      borderRadius='8px'
      boxShadow='md'
      display='flex'
      flexDirection='row'
      gap='8px'
      justifyContent='space-between'
      padding='32px'
      position='relative'
      _focusWithin={{
        borderColor: 'blue.500',
      }}
      _hover={{
        borderColor: 'blue.500',
      }}
    >
      <Box display='flex' flexDirection='column'>
        <LinkOverlay href={job.absoluteUrl} outline='none' rel='noreferrer noopener' target='_blank' isExternal>
          <Heading size='marketing-lg'>{job.title}</Heading>
          <Text fontSize='16px'>{job.locationName}</Text>
        </LinkOverlay>
      </Box>
      <Box>
        <ChevronRightIcon color='blue.500' height='32px' width='32px' />
      </Box>
    </LinkBox>
  );
}
